import Vue from 'vue';
import Swiper from 'swiper';

Vue.component('testimonial-slider', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiper: null,
            swiperEl: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.swiperEl = this.$el.querySelector('.testimonials');

        this.swiper = new Swiper(this.swiperEl, {
            loop: true,
            slidesPerView: 1.15,
            spaceBetween: 20,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.2,
                    spaceBetween: 32,
                    centeredSlides: true,
                },
                1024: {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                },

                1440: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    centeredSlides: true,
                },
                1680: {
                    slidesPerView: 2.5,
                    spaceBetween: 40,
                    centeredSlides: true,
                },
            },
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        handlePrevious() {
            this.swiper.slidePrev();
        },

        handleNext() {
            this.swiper.slideNext();
        },
    },

    onDestroy() {
        for (let i = 0; i < this.swiperSlides.length; i++) {
            this.swiperSlides[i].removeEventListener('click', this.togglePopup);
        }
    },
});
